(function () {
  "use strict";

  document.addEventListener("DOMContentLoaded", () => {

    //  BUNDLE + CHECKOUT LOGIC 

    const hiddenInput = document.getElementById("bundleSelection");
    const addon = document.getElementById("toggle-addon");
    const checkoutBtn = document.getElementById("landing-checkout");

    const discountCodesEl = document.getElementById("bundleDiscountCodes");
    const discountCodes = {
      "10": discountCodesEl?.dataset?.d10 || "",
      "15": discountCodesEl?.dataset?.d15 || "",
      "20": discountCodesEl?.dataset?.d20 || ""
    };

    function updatePriceDisplay(radio) {
      const priceContainer = document.querySelector(".product-price");
      if (!priceContainer || !radio) return;

      const newPrice = radio.dataset.newPrice;
      const oldPrice = radio.dataset.oldPrice;
      const discount = radio.dataset.discount;
      const perUnit  = radio.dataset.perUnit;
      const bundleType = radio.dataset.bundle;

      if (!newPrice) return;

      let html = '';

      if (oldPrice) {
        html += `<span class="price__compare">${oldPrice}</span>`;
      }

      html += `<span class="price__current">${newPrice}</span>`;

      if (discount && discount !== "0") {
        html += `<span class="discount-tag">-${discount}%</span>`;
      }

      if (discount == "0" && bundleType == "complete-kit") {
        html += `<span class="discount-tag">-20%</span>`;
      }

      if (perUnit) {
        html += `<span class="price__per-unit">${perUnit}</span>`;
      }

      priceContainer.innerHTML = html;
    }

    function buildCartItems(data) {
      const { variantId, qty = 1, handleVariantId, handleQty = 0, addon: hasAddon, addonId, addonQty = 1 } = data;

      const items = [];

      if (!variantId) return items;

      items.push({
        id: Number(variantId),
        quantity: Number(qty) || 1
      });

      if (handleVariantId && Number(handleQty) > 0) {
        items.push({
          id: Number(handleVariantId),
          quantity: Number(handleQty)
        });
      }

      if (hasAddon === "true" && addonId) {
        items.push({
          id: Number(addonId),
          quantity: Number(addonQty) || 1
        });
      }

      return items;
    }

    function updateCheckoutUrl() {
      if (!checkoutBtn || !hiddenInput) return;

      const { variantId, qty = 1, handleVariantId, handleQty = 0, addon: hasAddon, addonId, addonQty = 1, discount } = hiddenInput.dataset;

      if (!variantId) return;

      let cartParts = [`${variantId}:${qty}`];

      if (handleVariantId && Number(handleQty) > 0) {
        cartParts.push(`${handleVariantId}:${handleQty}`);
      }

      if (hasAddon === "true" && addonId) {
        cartParts.push(`${addonId}:${addonQty}`);
      }

      let url = `/cart/${cartParts.join(',')}`;

      if (discount && discountCodes[discount]) {
        url += `?discount=${discountCodes[discount]}`;
      }

      checkoutBtn.href = url;
    }

    function updateBundleSelection(radio) {
      if (!hiddenInput || !radio) return;

      hiddenInput.dataset.variantId       = radio.value;
      hiddenInput.dataset.qty             = radio.dataset.qty || 1;
      hiddenInput.dataset.discount        = radio.dataset.discount || 0;
      hiddenInput.dataset.handleVariantId = radio.dataset.handleVariant || "";
      hiddenInput.dataset.handleQty       = radio.dataset.handleQty || 0;

      updatePriceDisplay(radio);
      updateCheckoutUrl();

      if (window.syncSliderWithBundle) {
        window.syncSliderWithBundle(
          radio.value,
          radio.dataset.qty,
          radio.dataset.handleVariant || null,
          radio.dataset.handleQty || 0
        );
      }
    }

    function initActiveTabRadio() {
      const activeTab = document.querySelector('.tab-content.active');
      const firstInActiveTab = activeTab?.querySelector('input[name="bundle"]');
      if (firstInActiveTab) {
        firstInActiveTab.checked = true;
        updateBundleSelection(firstInActiveTab);
      }
    }

    if (checkoutBtn) {
      checkoutBtn.addEventListener("click", function (e) {
        if (!hiddenInput?.dataset?.variantId || this.href.includes("undefined")) {
          e.preventDefault();
          return;
        }

        this.classList.add("is-loading");
        this.style.pointerEvents = "none";
        this.style.opacity = "0.7";
        this.textContent = "Processing...";
      });
    }

    if (addon) {
      let addonQty = 1;
      const qtyWrapper = document.getElementById("addon-qty-wrapper");
      const qtyDisplay = document.getElementById("addon-qty-display");
      const qtyMinus   = document.getElementById("addon-qty-minus");
      const qtyPlus    = document.getElementById("addon-qty-plus");
      const priceEl    = document.querySelector(".action-container .price");

      function getBasePrice() {
        return parseInt(priceEl?.dataset?.basePrice || 0, 10);
      }

      function updateAddonPrice() {
        if (!priceEl) return;
        const base = getBasePrice();
        const total = ((base * addonQty) / 100).toFixed(2);
        priceEl.textContent = `$${total}`;
      }

      function syncAddon() {
        const isChecked = addon.checked;
        hiddenInput.dataset.addon    = isChecked ? "true" : "false";
        hiddenInput.dataset.addonId  = isChecked ? addon.value : "";
        hiddenInput.dataset.addonQty = isChecked ? addonQty : 0;

        if (qtyWrapper) {
          qtyWrapper.setAttribute("aria-hidden", !isChecked);
          qtyWrapper.style.display = isChecked ? "flex" : "none";
        }

        updateCheckoutUrl();
      }

      if (qtyMinus) {
        qtyMinus.addEventListener("click", (e) => {
          e.preventDefault();
          if (addonQty > 1) {
            addonQty--;
            qtyDisplay.textContent = addonQty;
            hiddenInput.dataset.addonQty = addonQty;
            updateAddonPrice();
            updateCheckoutUrl();
          }
        });
      }

      if (qtyPlus) {
        qtyPlus.addEventListener("click", (e) => {
          e.preventDefault();
          if (addonQty < 10) {
            addonQty++;
            qtyDisplay.textContent = addonQty;
            hiddenInput.dataset.addonQty = addonQty;
            updateAddonPrice();
            updateCheckoutUrl();
          }
        });
      }

      addon.addEventListener("change", syncAddon);
      syncAddon();
    }

    document.addEventListener("change", (e) => {
      const radio = e.target.closest('input[name="bundle"]');
      if (radio) updateBundleSelection(radio);
    });

    initActiveTabRadio();

    // Fix for back/forward history
    window.addEventListener("pageshow", () => {
      initActiveTabRadio();

      if (addon) {
        hiddenInput.dataset.addon   = addon.checked ? "true" : "false";
        hiddenInput.dataset.addonId = addon.checked ? addon.value : "";
      }

      updateCheckoutUrl();

      if (checkoutBtn) {
        checkoutBtn.classList.remove("is-loading");
        checkoutBtn.style.pointerEvents = "";
        checkoutBtn.style.opacity = "";
        checkoutBtn.textContent = "BUY NOW";
      }
    });

    /* --- Collapsible Row --- */

    document.addEventListener("click", (e) => {
      const button = e.target.closest(".collapsible-row__button");
      if (!button) return;

      const row = button.closest(".collapsible-row");
      const content = row.querySelector(".collapsible-row__content");
      const inner = content.querySelector(".collapsible-row__content-inner");

      const isOpen = button.getAttribute("aria-expanded") === "true";

      button.setAttribute("aria-expanded", !isOpen);
      content.setAttribute("aria-hidden", isOpen);

      if (isOpen) {
        content.style.maxHeight = content.scrollHeight + "px";
        requestAnimationFrame(() => {
          content.style.maxHeight = "0px";
        });
      } else {
        content.style.maxHeight = inner.scrollHeight + "px";
      }
    });

    /* --- Tabs --- */

    window.switchTab = function (evt, tabName) {
      document.querySelectorAll(".tab-content")
        .forEach(tab => tab.style.display = "none");

      document.querySelectorAll(".tab-button")
        .forEach(btn => btn.classList.remove("active"));

      const activeTab = document.getElementById(tabName);
      if (activeTab) activeTab.style.display = "block";

      evt.currentTarget.classList.add("active");

      document.querySelectorAll('input[name="bundle"]')
        .forEach(r => r.checked = false);

      const firstRadio = activeTab?.querySelector('input[name="bundle"]');
      if (firstRadio) {
        firstRadio.checked = true;
        updateBundleSelection(firstRadio);
      }
    };

  });
})();


// Add to Cart Button - Opens Quick Cart
(function() {
  const addToCartBtn = document.getElementById("landing-atc");
  const hiddenInput = document.getElementById("bundleSelection");

  const discountCodesEl = document.getElementById("bundleDiscountCodes");
  const discountCodes = {
    "10": discountCodesEl?.dataset?.d10 || "",
    "15": discountCodesEl?.dataset?.d15 || "",
    "20": discountCodesEl?.dataset?.d20 || ""
  };

  if (!addToCartBtn || !hiddenInput) return;

  addToCartBtn.addEventListener("click", async function(e) {
    e.preventDefault();

    const {
      variantId,
      qty,
      handleVariantId,
      handleQty = 0,
      addon: hasAddon,
      addonId,
      addonQty = 1,
      discount
    } = hiddenInput.dataset;

    if (!variantId) {
      document.querySelector('.bundle-selection-container')
        ?.scrollIntoView({ behavior: 'smooth' });
      return;
    }

    const items = [];

    items.push({
      id: Number(variantId),
      quantity: Number(qty) || 1
    });

    if (handleVariantId && Number(handleQty) > 0) {
      items.push({
        id: Number(handleVariantId),
        quantity: Number(handleQty)
      });
    }

    if (hasAddon === "true" && addonId) {
      items.push({
        id: Number(addonId),
        quantity: Number(addonQty) || 1
      });
    }

    const originalText = this.textContent;
    this.textContent = "Adding...";
    this.style.opacity = "0.7";
    this.style.pointerEvents = "none";

    try {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items })
      });

      if (discount && discountCodes[discount]) {
        await fetch(`/discount/${discountCodes[discount]}`);
      }

      const cartData = await fetch('/cart.js').then(res => res.json());
      const cartCountEls = document.querySelectorAll('[data-js-cart-count]');
      cartCountEls.forEach(el => {
        el.textContent = cartData.item_count;
      });

      const response = await fetch('/?section_id=quick-cart');
      const html = await response.text();

      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = html;

      const newInner = tempDiv.querySelector(".quick-cart__container");
      const currentInner = document.querySelector(".quick-cart__container");

      if (newInner && currentInner) {
        currentInner.innerHTML = newInner.innerHTML;
        currentInner.classList.toggle("updated");

        const crossSellsNode = currentInner.querySelector('[data-cross-sells]');
        if (crossSellsNode && typeof CrossSells === 'function') {
          CrossSells(crossSellsNode);
        }
      }

      const cartIcon = document.querySelector('[data-js-cart-icon]');
      cartIcon?.click();

    } catch (error) {
      console.error("Cart error:", error);
    } finally {
      this.textContent = originalText;
      this.style.opacity = "";
      this.style.pointerEvents = "";
    }
  });
})();


// Bundle scrolls the slider + updates badge
(function() {
  function syncSliderWithBundle(variantId, qty, handleVariantId, handleQty) {
    if (!variantId) return;
    if (window.sliderGoToSlide) {
      window.sliderGoToSlide(variantId, qty, handleVariantId, handleQty);
    }
  }
  window.syncSliderWithBundle = syncSliderWithBundle;
})();


// Nav Menu Error Fix
(function() {
  function initDrawerAnchors() {
    var menuLinks = document.querySelectorAll('.drawer-menu__link');
    var closeButton = document.querySelector('.icon-button-header-menu-close');

    if (!menuLinks.length) return;

    for (var i = 0; i < menuLinks.length; i++) {
      (function(index) {
        var link = menuLinks[index];

        link.addEventListener('click', function(e) {
          var href = this.getAttribute('href');

          if (href && href.indexOf('#') !== -1) {
            e.preventDefault();

            var targetId = href.split('#')[1];
            var targetElement = document.getElementById(targetId);

            if (closeButton) {
              closeButton.click();
            }

            setTimeout(function() {
              if (targetElement) {
                targetElement.scrollIntoView({
                  behavior: 'smooth',
                  block: 'start'
                });

                if (history.pushState) {
                  history.pushState(null, null, '#' + targetId);
                } else {
                  location.hash = targetId;
                }
              } else {
                window.location.href = href;
              }
            }, 400);
          }
        });
      })(i);
    }
  }

  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    initDrawerAnchors();
  } else {
    document.addEventListener('DOMContentLoaded', initDrawerAnchors);
  }
})();

window.addEventListener("pageshow", function (event) {
  if (event.persisted || window.performance.getEntriesByType("navigation")[0]?.type === "back_forward") {
    window.location.reload();
  }
});